import React, { Component } from 'react';
import './BbTopic.css';
import './BbBannerShared.css';

class BbTopic extends Component
{
  render() {
    const topic = this.props.topic !== undefined ? this.props.topic : 'unknown';
    return (
      <div id="topic" className="BbBannerShared.css">
        {topic}
      </div>
    );
  }
}

export default BbTopic;
